// AgenticNodeFrame — wrapper that visually signals "agent step" at-a-glance.
// Dashed border + gradient overlay matching step-constants color tokens;
// no semantic-status overlap with status-color border.
// Applied only to the 5 agentic step types; ETL nodes pass through unchanged.
import { cn } from "@/utils";

interface AgenticNodeFrameProps {
  children: React.ReactNode;
  variant?: "etl" | "agentic";
  className?: string;
}

export function AgenticNodeFrame({
  children,
  variant = "etl",
  className,
}: AgenticNodeFrameProps) {
  if (variant !== "agentic") {
    // ETL steps: render children unmodified — no border injection.
    return <>{children}</>;
  }

  return (
    <div
      // Dashed border + gradient signals "agent step" at-a-glance per design
      // system token map; no semantic-status overlap with status-color border.
      className={cn(
        "relative rounded-xl",
        "border-2 border-dashed border-purple-400/70 dark:border-purple-500/60",
        "before:pointer-events-none before:absolute before:inset-0 before:rounded-xl",
        "before:bg-gradient-to-br before:from-purple-500/5 before:to-fuchsia-500/5",
        className
      )}
    >
      {children}
    </div>
  );
}

export default AgenticNodeFrame;
